<template>
<div class="d-flex flex-column sticky-footer-wrapper">
    <main class="flex-fill">
      <app-header ref="header"></app-header>
      <message-component></message-component>
      <div class="container mt-3">
          <div class="row">
            <div class="col-md-12" style="margin-top: 100px">
              <router-view></router-view>
            </div>
          </div>
      </div>
    </main>

    <footer class="navbar-default navbar-bottom navbar-dark bg-dark">
      <div class="container-fluid">
            <!-- <p class="text-center nav-bar mb-0">
              <a href="https://www.signledger.com" target="_blank">
                SignLedger
              </a>
            </p> -->
            <div class="text-center">
              <a href="https://www.signledger.com" target="_blank">SignLedger LLC</a>
              <span class="ml-1">&copy; {{new Date().getFullYear()}} </span>
            </div>
            <!-- <p class="text-center nav-bar mb-0">Checkout repository at <a href="https://github.com/ittus/vuejs-firebase-shopping-cart" target="_blank">
              https://github.com/ittus/vuejs-firebase-shopping-cart
            </a></p> -->
      </div>
    </footer>
</div>

</template>

<script>
  import Header from './components/Header.vue';
  import MessageComponent from './components/common/MessageComponent.vue';
  import { onMessage } from "firebase/messaging";
  import { messaging } from './config/firebaseConfig.js'

  onMessage(messaging, (payload) => {
    window.current.$alert(payload.notification.body, payload.notification.title)
    window.current.$router.push('/messages')
    window.current.$refs.header.menuChange('messages')
  });

  export default {
    components: {
      appHeader: Header,
      MessageComponent
    },

    mounted(){
      window.current=this

      // Register FCM Service worker
      // let regStatus = ''
      // if ('serviceWorker' in navigator) {
      //   navigator.serviceWorker.register('firebase-messaging-sw.js').then(function(reg) {
      //     if(reg.installing) {
      //       regStatus = 'installing'
      //     } else if(reg.waiting) {
      //         regStatus = 'installed'
      //     } else if(reg.active) {
      //       regStatus = 'active'
      //     }
      //     console.log("FCM Service worker registration status: " + regStatus)
      //   })
      // } else {
      //   // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
      //   console.warn('Service Worker not available');
      // }

    },

    created() {
      let orgId = this.$route.params.orgId;

      if(!orgId){
        this.$router.push('/home')
      }
      else {
        // Check if org exists in List of SL Orgs

        // Temp ***
        if (orgId == "1" || orgId.toLowerCase() == 'ketco' || orgId.toLowerCase() == 'demo'){
          this.$router.push({ name: 'mainpage', params: { orgId: orgId } })
        }
        else{
          this.$alert("'" + orgId + "' is not registered for SignLedger Services.")
          this.$router.push('/home')
        }
      }
    
    },

    methods: {
    }

  }
</script>

<style>

  #reset-store-panel {
    position: fixed; bottom: 0px; right: 0px;
  }

  body, .sticky-footer-wrapper {
     min-height:100vh;
  }

  .flex-fill {
     flex:1 1 auto;
  }
  footer {
    height: 40px;
    color: #666;
    padding: 10px 0 10px 0;
    font-size: 85%;
  }
  footer a {
    color: #999;
  }
  footer a:hover {
    color: #efefef;
  }
  @media (max-width: 576px) {
    footer {
      height: 50px;
    }
  }
</style>
